import {
  AppBar,
  createStyles,
  IconButton,
  Menu,
  MenuItem,
  Theme,
  Toolbar,
  Typography,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import UserIcon from "@material-ui/icons/AccountCircle";
import * as React from "react";
import { Link } from "react-router-dom";
import NetworkState from "./NetworkState";
import { useStore } from "lib/store";
import { useMutation } from "@tanstack/react-query";
import { actionLogout } from "lib/store/Actions";

const HomeLink = (props: any) => <Link to="/" {...props} />;

const styles = (theme: Theme) =>
  createStyles({
    username: {
      flexGrow: 1,
      textAlign: "right",
      textDecoration: "none",
    },
  });

interface Props extends WithStyles<typeof styles> {}

const TopBar: React.FC<Props> = ({ classes }) => {
  const [menuAnchor, setMenuAnchor] = React.useState<HTMLElement | null>(null);
  const [state, dispatch] = useStore();
  const isMenuOpen = Boolean(menuAnchor);

  const closeMenu = React.useCallback(() => {
    setMenuAnchor(null);
  }, []);

  const handleMenuClose = React.useCallback(
    (event: React.SyntheticEvent<{}, Event>) => {
      closeMenu();
    },
    [closeMenu]
  );

  const handleProfileMenuOpen = React.useCallback(
    (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
      const target = event.currentTarget;
      setMenuAnchor(target);
    },
    []
  );

  const logoutMutation = useMutation({
    mutationFn: async () => {
      closeMenu();
      return state.apiClient.POST("/api/auth/logout");
    },
    onSuccess: () => {
      dispatch(actionLogout());
    },
  });

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton color="inherit" aria-label="Menu">
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component={HomeLink}
            color="inherit"
            noWrap={true}
            className={classes.username}
          >
            <span>{state.user?.name}</span>
          </Typography>
          <NetworkState />
          <IconButton
            color="inherit"
            aria-owns={isMenuOpen ? "material-appbar" : undefined}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
          >
            <UserIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={menuAnchor}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={isMenuOpen}
        onClose={handleMenuClose}
        getContentAnchorEl={null}
      >
        <MenuItem onClick={() => logoutMutation.mutate()}>Déconnecter</MenuItem>
      </Menu>
    </div>
  );
};

export default withStyles(styles)(TopBar);
